import { render, staticRenderFns } from "./ShopItemView.vue?vue&type=template&id=c13cb51a&scoped=true&lang=html&"
import script from "./ShopItemView.vue?vue&type=script&lang=js&"
export * from "./ShopItemView.vue?vue&type=script&lang=js&"
import style0 from "./ShopItemView.vue?vue&type=style&index=0&id=c13cb51a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c13cb51a",
  null
  
)

export default component.exports